import './loaders.scss';

export default function Loading() {
	return (
		<div className="creative-loading-container">
			{/* Animated background particles */}
			<div className="floating-particles">
				<div className="particle particle-1"></div>
				<div className="particle particle-2"></div>
				<div className="particle particle-3"></div>
				<div className="particle particle-4"></div>
				<div className="particle particle-5"></div>
			</div>

			{/* Main logo with creative animations */}
			<div className="logo-showcase">
				{/* Animated rings around logo */}
				<div className="logo-ring ring-outer"></div>
				<div className="logo-ring ring-middle"></div>
				<div className="logo-ring ring-inner"></div>

				{/* Logo with breathing effect */}
				<div className="logo-container">
					<img src="/logoCircleDark.png" alt="Loading..." className="creative-logo" />
					{/* Subtle glow effect */}
					<div className="logo-glow"></div>
				</div>

				{/* Loading dots */}
				<div className="loading-dots">
					<div className="dot dot-1"></div>
					<div className="dot dot-2"></div>
					<div className="dot dot-3"></div>
				</div>
			</div>
		</div>
	);
}
